<template>
  <form class="new-password auth__form" @submit.prevent="">
    <header>
      <h3>Укажи новый пароль</h3>
    </header>
    <main>
      <Input
        v-model="$v.form.password.$model"
        class="new-password__input"
        :error="!editingPassword && ($v.form.password.$error || !passwordRepeated)"
        :tooltip-options="{
          placement: 'top',
          trigger: 'hover',
          open: editingPassword,
          autoHide: false
        }"
        :error-message="formErrors.password"
        :is-tooltip="true"
        :new-password="true"
        label="Пароль"
        placeholder="Введи пароль"
        type="password"
        @focus="editingPassword = true"
        @blur="editingPassword = false"
        @mouseenter="editingPassword = true"
        @mouseleave="editingPassword = false"
      >
        <template #tooltip>
          <PasswordPopup :password-validator="$v.form.password" />
        </template>
      </Input>

      <Input
        v-model="$v.form.passwordRepeat.$model"
        :error="!editingRepeatPassword && ($v.form.passwordRepeat.$error || !passwordRepeated)"
        :new-password="true"
        label="Повтори пароль"
        placeholder="Введи пароль повторно"
        type="password"
        @focus="editingRepeatPassword = true"
        @blur="editingRepeatPassword = false"
      />
      <Button
        class="new-password__button double-col"
        :disabled="!canRegister"
        :loading="isLoading"
        @click="submit()"
      >
        Войти
      </Button>
    </main>

    <footer>
      Нет аккаунта?
      <router-link to="/registration"> Регистрация </router-link>
    </footer>
  </form>
</template>

<script>
import Input from '@/components/UiKit/v2/Input';
import PasswordPopup from '../../components/PasswordPopup';
import { required, maxLength, minLength } from 'vuelidate/lib/validators';
import Button from '@/components/UiKit/v2/Button';
import { mapState } from 'vuex';

export default {
  name: 'NewPassword',
  components: {
    Input,
    Button,
    PasswordPopup
  },
  data: () => ({
    form: {
      password: '',
      passwordRepeat: ''
    },
    editingPassword: false,
    editingRepeatPassword: false
  }),
  computed: {
    ...mapState('security', {
      isLoading: state => state.meta.registering
    }),
    passwordRepeated() {
      return this.form.password === this.form.passwordRepeat;
    },
    formErrors() {
      const errors = {
        password: '',
        passwordRepeat: ''
      };

      if (this.$v.form.$anyError || !this.passwordRepeated) {
        if (this.$v.form.password.$error || !this.passwordRepeated) {
          errors.password = this.$v.form.password.$error
            ? 'Некорректный пароль'
            : !this.passwordRepeated
            ? 'Пароли не совпадают'
            : '';
        }
      }

      return errors;
    },
    canRegister() {
      return !this.$v.form.$invalid && this.passwordRepeated;
    }
  },
  methods: {
    async submit() {
      if (!this.$v.$invalid) {
        const dataForm = {
          newPassword1: this.form.password,
          newPassword2: this.form.passwordRepeat
        };
        const res = await this.$store.dispatch('security/changePassword', {
          user: dataForm,
          hash: this.$route.params.hash
        });
        if (res === 'success') {
          await this.$router.replace('/login');
        }
      }
    }
  },
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(64),
        uppercase: v => /[A-Z]/.test(v),
        lowercase: v => /[a-z]/.test(v),
        numbers: v => /[0-9]/.test(v)
      },
      passwordRepeat: {
        required
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/style/utils';
.new-password {
  width: 440px;

  @media all and (max-width: 1280px) {
    width: 100%;
  }

  &__input {
    margin-bottom: 14px;
  }

  &__button {
    margin-top: 30px;

    @media all and (max-width: 1280px) {
      margin-top: 16px;
    }
  }

  main {
    margin-bottom: 60px;

    @media all and (max-width: 1280px) {
      margin-bottom: 134px;
    }
  }
}
</style>
